<template>
    <div class="box">
        <h1>{{checkInfo.smTitle}}</h1>
        <div class="text">
            <pre>{{checkInfo.smText}}</pre>
        </div>
        <div class="info">
            <!--<p><span>시스템 점검시간</span> (2시간 예정)</p>-->
            <p>{{checkInfo.smSubTitle}}</p>
            <div class="time">
                {{checkInfo.smDate}}
            </div>
        </div>
        <p><img src="/images/maintenance/web_error_logo.png" alt="더해"></p>
    
    </div>
</template>

<script>
import $ from 'jquery'
import Vue from "vue";
import VueHead from "vue-head";
import { severCheckInfo } from "@/api/common";
Vue.use(VueHead);
export default {
    head: {
        title: {

            inner: "더해",
        },
        meta: [{ charset: "UTF-8" }, { name: "viewport", content: '"width=750, user-scalable=no' }, { name: "apple-mobile-web-app-title", content: "더해" }, { name: "apple-mobile-web-app-capable", content: "yes" }, { name: "msapplication-TileColor", content: "#ffffff" }, { name: "theme-color", content: "#ffffff" }, { name: "msapplication-TileImage", content: "/ms-icon-144x144.png" }, { name: "apple-mobile-web-app-status-bar-style", content: "default" }, { property: 'og:url"', content: "" }, { property: 'og:title"', content: "더해" }, { property: 'og:type"', content: "website" }, { property: 'og:image"', content: "images/favicon/og.png" }, { property: 'og:description"', content: "즐거움과 혜택이 더해지는 커뮤니티 플랫폼" }],
        link: [
        
        ],
    },
    data() {
        return{
            checkInfo:{},
        }
    },
    created() {
        window.VueRoot=this;
        // remove common css
        this.getServerCheckInfo();
        // 점검 해제
    },
    mounted() {
            this.interval = setInterval(function(){
	            window.VueRoot.getServerCheckInfo()
	        },10000);
        },
    methods: {
        getServerCheckInfo() {
            severCheckInfo( )
            .then(({ data }) => {
                this.checkInfo = data.checkInfo;
                try{
                    if(data.checkInfo.status == "N") {
                        clearInterval(window.VueRoot.interval);
                        alert("기다려 주셔서 감사합니다.\n서버 점검이 완료되었습니다.")
                        window.location.href = "/main"
                    }

                }catch(e){
                    console.log(e);
                }
            })
        },   
    }
}
</script>

<!--<style scoped>-->
<style>
    html { 
        zoom: 1.3;
    }
    @-ms-viewport{ width:750px;}
    @-o-viewport{ width:750px;}
    @viewport{ width:750px;}
    *{margin:0px;padding:0px}
        .box{
            border: 10px solid #e8e8e8;
            box-sizing: border-box;
            text-align:center;
            padding:50px;
            width:680px;
            margin:0 auto;
            position:absolute;
            top:50%;
            left:50%;
            transform: translate(-50%, -50%);
        }
        .text{color:#7d7d7d;margin-top:30px;font-weight:bold}
        .text pre {font-size:20px; white-space: pre-wrap;}
        .text p + p{margin-top:5px;}
        .text p.blue{color:#08a1f1}
        /*.info{width:345px;border-top:1px solid #e8e8e8;padding-top:30px;margin:30px auto;}*/
        .info{width:400px;border-top:1px solid #e8e8e8;padding-top:30px;margin:30px auto;}
        .info p{font-weight:bold;font-size:20px;margin-bottom:10px;letter-spacing:-1px}
        .info span{color:#08a1f1}
        .info .time{border:2px solid #b4b4b4;padding:10px 50px;text-align:left;font-size:20px;font-weight:bold;background: linear-gradient(#fff, #eee);}
    
    @media (max-width: 680px) {
        .box{width:90%;box-sizing: border-box;padding: 20px 10px;}
        .info{width:100%}
        .info .time{width:100%;box-sizing:border-box;padding:10px}
    }
    
    @media (max-width: 320px) {
        h1{font-size:18px}
        .info p{font-size:18px}
        .info .time{font-size:18px}
    }
</style>
